import React, { Component } from 'react';
import ChangePassword from './ChangePassword'
import { connect } from 'react-redux'
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'

import { SignOutActions } from '../../../../store';
/**
 * ChangePasswordContainer connects all the redux store and action to ChangePassword component
 */
class ChangePasswordContainer extends Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentWillMount() {
        let i18n;
        if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
            i18n = getKeyFromLS("i18n");
        } else {
            i18n = this.props.i18n
        }
        this.setState({
            i18n: i18n
        })
    }

    render() {
        return (<ChangePassword {...this.props} {...this.state} />);
    }

}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        signOutUser: () => SignOutActions.signOut(dispatch),
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

        loginState: state.cognito.state,
        user: state.cognito.user,
        attributes: state.cognito.attributes,
        i18n: state.i18nMessages.i18n
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordContainer);